import React from 'react';
import { useAppSelector } from '../Store/store.ts';
import { CurrentStepSelector } from '../Selectors/FitAssistantSelectors.ts';
import FitAssistantStep from '../Enums/FitAssistantStep.ts';
import NoFit from '../Components/NoFit/NoFit.tsx';
import OtherFits from '../Components/OtherFits/OtherFits.tsx';
import SelectList from '../Components/SelectList/SelectList.tsx';
import Unconfirmed from '../Components/Unconfirmed/Unconfirmed.tsx';
import VariationSelector from '../Components/VariationSelector/VariationSelector.tsx';

export const Awnings = () => {
  const currentStep = useAppSelector(CurrentStepSelector);

  const RenderStep = () => {
    switch (currentStep) {
      case FitAssistantStep.Make:
      case FitAssistantStep.Model:
      case FitAssistantStep.Year:
      case FitAssistantStep.VanSize:
        return <SelectList />;
      case FitAssistantStep.Variation:
        return <VariationSelector />;
      case FitAssistantStep.NoFits:
        return <NoFit />;
      case FitAssistantStep.OtherFits:
        return <OtherFits />;
      case FitAssistantStep.Unconfirmed:
        return <Unconfirmed />;
      default:
        return <></>;
    }
  };

  return <>{RenderStep()}</>;
};

export default Awnings;
